import { render } from "./VWeeklyTreatment.vue?vue&type=template&id=0969d81c"
import script from "./VWeeklyTreatment.vue?vue&type=script&lang=js"
export * from "./VWeeklyTreatment.vue?vue&type=script&lang=js"

import exportComponent from "/apps/releases/202604221556/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/platform/components/offline-booking/VWeeklyTreatment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0969d81c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0969d81c', __exports__)) {
    api.reload('0969d81c', __exports__)
  }
  
  module.hot.accept("./VWeeklyTreatment.vue?vue&type=template&id=0969d81c", () => {
    api.rerender('0969d81c', render)
  })

}


export default __exports__